import { LabelSize } from 'label/utils/types';
import { HubState } from 'root/apps/pages/store/reducers/hub';

export enum HUB_MESSAGES {
  GET_CONFIG = 'GET_CONFIG',
  GET_CHANNEL_NAME = 'GET_CHANNEL_NAME',
  UPDATE_CHANNEL_NAME = 'UPDATE_CHANNEL_NAME',
  UPDATE_CONFIG = 'CONFIG_UPDATED',
  DISCONNECT = 'DISCONNECT',
  DEVICES = 'DEVICES',
}

export const isHubMessage = (str: string): str is HUB_MESSAGES =>
  Object.values(HUB_MESSAGES).includes(str as HUB_MESSAGES);

export enum CFD_MESSAGES {
  UPDATE_SALE = 'SALE_UPDATED',
  COMPLETE_SALE = 'SALE_COMPLETED',
  TIP_FLOW_START = 'TIP_FLOW_START',
  HIDE_SALE = 'HIDE_SALE',
  SHOW_SALE = 'SHOW_SALE',
  CLOSE = 'CLOSE',
  TIP_CONFIRMED = 'TIP_CONFIRMED',
}

export const isCfdMessage = (str: string): str is CFD_MESSAGES =>
  Object.values(CFD_MESSAGES).includes(str as CFD_MESSAGES);

export enum PRINTER_MESSAGES {
  PRINT = 'PRINT',
  PRINT_COMPLETED = 'PRINT_COMPLETED',
  PRINT_ERROR = 'PRINT_ERROR',
}

export const isPrinterMessage = (str: string): str is PRINTER_MESSAGES =>
  Object.values(PRINTER_MESSAGES).includes(str as PRINTER_MESSAGES);

export enum STATUS {
  ERROR = 'Error',
  DISCONNECTED = 'Disconnected',
  CONNECTED = 'Connected',
  READY = 'Ready',
}

export enum PRINTER_KINDS {
  RECEIPT = 'RECEIPT',
  LABEL = 'LABEL',
}

export enum PRINTER_FORMATS {
  URL = 'URL',
  BUFFER = 'BUFFER',
  HTML = 'HTML',
  ZPL = 'ZPL',
}

export enum PRINTER_STATUSES {
  READY = 'READY',
  COVER_OPEN = 'COVER_OPEN',
  LOW_PAPER = 'LOW_PAPER',
  NO_PAPER = 'NO_PAPER',
  PAPER_JAM = 'PAPER_JAM',
  ERROR = 'ERROR',
  DISCONNECTED = 'DISCONNECTED',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  PAUSED = 'PAUSED',
  OVERHEATED = 'OVERHEATED',
  NOT_RESPONDING = 'NOT_RESPONDING',
}

export enum MEMBER_TYPE {
  RETAIL = 'RETAIL',
  CFD = 'CFD',
  HUB = 'HUB',
}

export interface PrintData {
  data: string;
  kind: PRINTER_KINDS;
  executionTimes: Record<string, number>;
  format: PRINTER_FORMATS;
  openCashDrawer?: boolean;
  size?: LabelSize;
}

interface CFDDevices {
  defaultPrinters: undefined;
  selectedDisplay: HubState['selectedDisplay'];
  version?: string;
}
interface HubDevices {
  defaultPrinters: HubState['defaultPrinters'];
  selectedDisplay: HubState['selectedDisplay'];
  version?: string;
}

export type Devices = CFDDevices | HubDevices;
